module.exports = __webpack_public_path__ + "files/SPIADI2024 - Journée Nationale - Pré-Programme.19f87091a935c11fd2be6deb085639a2.pdf";